import { render } from "./HelpDialogShareProject.vue?vue&type=template&id=84810dbe"
import script from "./HelpDialogShareProject.vue?vue&type=script&lang=js"
export * from "./HelpDialogShareProject.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__